export { PageUsersComponent as PageUsers } from './component';



// WEBPACK FOOTER //
// ./src/pages/users/index.tsx